<template>
  <div class="py-2 px-md-0 py-md-4">
<!--    <button onclick="window.ChatWidget.init()">-->
<!--      Відкрити чат-->
<!--    </button>-->
    <banner-component :img-name="bannerImgSid" :img-url="bannerImgUrl" :img-ext="isKle ? 'gif' : undefined" :individual="individualBanner" title="" class="banner-component">
      <template v-if="isHeroLogo" #media>
        <div class="welcome-hero bg-white d-flex align-items-center px-3 py-4 p-md-5">
          <b-row class="w-100 align-items-center" no-gutters>
            <b-col cols="12" lg="6" class="text-center text-lg-left">
              <img :src="require('@/assets/img/banner/en/welcome_logo.jpg')" alt="Jobcenter EN" class="img-fluid" />
            </b-col>
            <b-col cols="12" lg="6" class="mt-4 mt-lg-0 pl-lg-5">
              <p class="welcome-hero__text m-0">{{ heroText }}</p>
            </b-col>
          </b-row>
        </div>
      </template>
      <b-row class="w-100" no-gutters>
        <b-col cols="12" v-if="!isHeroLogo">
          <b-row no-gutters class="justify-content-center">
            <b-col
              v-for="(item, index) in countsData"
              :key="index"
              cols="12"
              :md="countsData.length === 2 ? 6 : 4"
              class="pb-1 pb-md-4 px-1"
              :class="[{ 'mb-3': !isHide }]"
            >
              <p :class="[{'display-2': countsData.length > 2}]" class="welcome-count__number display-1 mb-0 text-center timer text-white">
                <ICountUp :delay="1000" :endVal="item.count" :options="options" />
              </p>
              <router-link :to="item.link" class="welcome-count__text d-block fs-4 mb-0 text-center text-white">
                <span class="fw-bolder" v-html="item.title"></span>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
<!--        isAI-->
        <b-col v-if="isHide && isEnabledAi" v-show="searchMode === 'ki'" cols="12" class="px-1 mb-1 mb-sm-0" xl>
          <div class="position-relative">
            <b-form-input
                style="border-radius: 5px; height: 48px;"
                v-model="aiSearchText"
                :placeholder="aiSearchPlaceholder"
                @keyup.enter="searchAi"
              ></b-form-input>
          </div>
        </b-col>
<!--        isAI-->
        <b-col v-if="isHide" v-show="!isEnabledAi || searchMode !== 'ki'" cols="12" class="px-1 mb-1 mb-sm-0" sm="6" xl>
          <div class="position-relative" v-show="!fulltext">
            <select-profession-update v-model="selectProfession" :fixed="true" />
          </div>
          <div class="position-relative" v-show="fulltext">
            <b-input-group>
              <b-form-input
                style="border-radius: 5px; height: 48px;"
                @keyup="clearProfession"
                v-model="searchText"
                :placeholder="translations[10431]"
              ></b-form-input>
              <b-input-group-append v-show="searchText.length">
                <b-button variant="primary" @click.prevent="searchText = ''">
                  <b-icon icon="x" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col v-if="isHide" v-show="!isEnabledAi || searchMode !== 'ki'" cols="12" class="order-2 order-sm-1 order-sm-2 px-1" sm="6" xl>
          <select-location-radius
            :radius.sync="radius"
            :placeholder="isHide ? searchPlaceholder : `${translations[13589]}...`"
            :lg="true"
            v-model="selectLocation"
          />
        </b-col>

        <b-col cols="12" class="order-1 order-sm-2 order-xl-3 px-1 mb-1">
          <ai-custom-checkbox v-if="isEnabledAi" :value="searchMode" @input="onSearchModeInput" />
          <div class="position-relative" v-else-if="isCurses">
            <div class="d-flex align-items-center job__messagebox-volltext" :class="[{ active: fulltext }]">
              <label class="volltext-label m-0 mr-2">{{ translations[3848] }}</label>
              <b-form-checkbox switch size="lg" v-model="fulltext" class="job__messagebox-checkbox">
                {{ translations[10434] }}
              </b-form-checkbox>
            </div>
          </div>
        </b-col>
        <b-col v-if="isHide" cols="12" class="order-3 order-sm-3 order-xl-2 px-0 mt-1 mt-xl-0" xl="auto">
          <b-row no-gutters>
            <!--        isAI-->
            <b-col class="px-1" v-if="isEnabledAi && searchMode === 'ki'">
              <b-button variant="primary" size="lg" class="w-100 d-flex align-items-center" :disabled="aiSearchLoading" @click="searchAi">
                <b-spinner v-if="aiSearchLoading" small class="mr-2"></b-spinner>
                {{ translations[13938] }}
              </b-button>
            </b-col>
            <!--        isAI-->
            <b-col class="px-1" v-else>
              <b-button variant="primary" size="lg" class="w-100" @click="search">{{ translations[13938] }}</b-button>
            </b-col>
            <b-col class="px-1">
              <b-button @click="searchFilter" variant="primary" size="lg" class="w-100 whitespace-nowrap" v-b-toggle.jobs-filter>
                <b-icon icon="sliders" class="d-inline-block d-sm-inline-block d-lg-none"></b-icon>
                <span class="ml-1 d-none d-sm-inline-block">{{ translations[13939] }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </banner-component>
    <b-row>
      <!-- <b-col cols="12" v-if="sid === 'jig'">
        <span class="present text-uppercase font-weight-light">JIG - JOBS IN GERMANY</span>
        <h2 style="font-weight: 600;">
          About Us?
        </h2>
        <p class="m-0 mb-4" style="font-size: 20px">
          JIG (Jobs In Germany) is an organization that provides consulting services on residence and work permits abroad. JIG is the result of 25 years of experience and is at your disposal with its professional staff. JIG is aimed specifically at young people and people who are looking for a career abroad, and offers professional advice to those who want to go this way. With our high-quality approach to service, people can be guided at any stage from their choice of destination abroad and even their next steps.
        </p>
      </b-col>
      <b-col cols="12" v-else-if="sid === 'talentpool'">
        <template v-if="lang === 'uk'">
          <h3 style="font-weight: 800;">
            Ласкаво просимо до бази даних кваліфікованих кадрів JobMATCH
          </h3>
          <p class="m-0 mb-4" style="font-size: 20px; font-weight: 600;">
            Платформа для іноземних кваліфікованих працівників, роботодавців та партнерів програми
          </p>
        </template>
        <template v-else-if="lang === 'en'">
          <h3 style="font-weight: 800;">
            Welcome to the JobMATCH Talent Pool
          </h3>
          <p class="m-0 mb-4" style="font-size: 20px; font-weight: 600;">
            The platform for international skilled workers, employers and program partners
          </p>
        </template>
        <template v-else>
          <h3 style="font-weight: 800;">
            Willkommen im JobMATCH Talentpool
          </h3>
          <p class="m-0 mb-4" style="font-size: 20px; font-weight: 600;">
            Die Plattform für internationale Arbeits- und Fachkräfte, Arbeitgeber und Programmpartner
          </p>
        </template>
      </b-col>
      <b-col cols="12" v-else-if="sid === 'edunet'">
        <template v-if="lang === 'uk'">
          <h3 style="font-weight: 800;">
            Ласкаво просимо до бази даних кваліфікованих кадрів Edunet
          </h3>
          <p class="m-0 mb-4" style="font-size: 20px; font-weight: 600;">
            Платформа для іноземних кваліфікованих працівників, роботодавців та партнерів програми
          </p>
        </template>
        <template v-else-if="lang === 'en'">
          <h3 style="font-weight: 800;">
            Welcome to the Edunet Talent Pool
          </h3>
          <p class="m-0 mb-4" style="font-size: 20px; font-weight: 600;">
            The platform for international skilled workers, employers and program partners
          </p>
        </template>
        <template v-else>
          <h3 style="font-weight: 800;">
            Willkommen im Edunet Talentpool
          </h3>
          <p class="m-0 mb-4" style="font-size: 20px; font-weight: 600;">
            Die Plattform für internationale Arbeits- und Fachkräfte, Arbeitgeber und Programmpartner
          </p>
        </template>
      </b-col>
      <b-col cols="12" v-else>
        <h2 v-html="translations[13940]"></h2>
        <p class="fw-bolder m-0 fs-4 mb-4" v-html="translations[13941]" />
      </b-col> -->
      <b-col>
        <h2 v-html="contentTitle"></h2>
        <p class="m-0 fs-4 mb-4" v-html="contentDescription" />
      </b-col>
    </b-row>

    <jobs-information-box :is-welcome="true" />
    <text-information-box />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import BannerComponent from '@/components/BannerComponent.vue';
import ProfessionsComponent from '@/components/Home/ProfessionsComponent.vue';
import NotAuthModal from '@/components/Core/NotAuthModal.vue';
import JobComponent from '@/components/Home/JobComponent.vue';
import JobComponentCluster from '@/components/Home/JobComponentCluster.vue';
import JobsInformationBox from '@/components/Home/JobsInformationBox.vue';
import TextInformationBox from '@/components/Welcome/TextInformationBox.vue';
import SelectProfession from '@/components/Widget/SelectProfession.vue';
import SelectLocation from '@/components/Widget/SelectLocation.vue';
import { ProfessionModule } from '@/store/modules/profession';
import { AppModule, SettingsCounters } from '@/store/modules/app';
import ICountUp from 'vue-countup-v2';
import { JobType } from '@/types/ProfessionType';
import { mixins } from 'vue-class-component';
import LocaleStringMixin from '@/mixins/LocaleStringMixin';
import AiJobSearchMixin from '@/mixins/AiJobSearchMixin';
import AnalysisMixin from '@/mixins/AnalysisMixin';
import { AnalysisType } from '@/types/Analysis';
import SelectProfessionUpdate from '@/components/Widget/SelectProfessionUpdate.vue';
import AiCustomCheckbox from '@/components/Core/Ai/AiCustomCheckbox.vue';
import { ThemesModule } from '@/store/modules/themes';
import { groupCurses, individualBannerGroup, portalBannerGroup } from '@/config/configuration';
import { SERVER_URL } from '@/config/constant';
import SelectLocationRadius from '@/components/Widget/SelectLocationRadius.vue';

@Component({
  metaInfo(this: any): any {
    return {
      title: this.pageTitles[this.lang] || this.pageTitles.de,
      meta: [{ name: 'description', content: this.pageDescriptions[this.lang] || this.pageDescriptions.de }],
    };
  },
  components: {
    SelectLocationRadius,
    BannerComponent,
    JobsInformationBox,
    ProfessionsComponent,
    NotAuthModal,
    JobComponent,
    SelectProfession,
    SelectLocation,
    ICountUp,
    TextInformationBox,
    JobComponentCluster,
    SelectProfessionUpdate,
    AiCustomCheckbox,
  },
})
export default class WelcomeView extends mixins(LocaleStringMixin, AiJobSearchMixin, AnalysisMixin) {
  fulltext = false;

  created() {
    this.setAnalysis(AnalysisType.PORTAL_START);
  }

  aiSearchText = '';

  aiSearchLoading = false;

  searchMode: 'ki' | 'berufsgruppe' | 'volltext' = 'ki';

  onSearchModeInput(mode: 'ki' | 'berufsgruppe' | 'volltext') {
    this.searchMode = mode;
    this.fulltext = mode === 'volltext';
  }

  clearProfession() {
    this.fulltext = true;
    this.searchMode = 'volltext';
    this.selectProfession = null;
  }

  get pageTitles() {
    return {
      de: this.title || this.titleSid.de,
      en: this.title || this.titleSid.en,
    };
  }

  get isEnabledAi() {
    return Number(AppModule.setting?.enable_ai_jobs_search) === 1;
  }

  get isCurses() {
    return groupCurses(this.sid);
  }

  pageDescriptions = {
    de: 'Jobs in Österreich suchen & finden ✔ Jobbörse für Österreich ✔ Jobaustausch für Arbeitnehmer & Arbeitgeber ✔ Jetzt informieren & in Österreich arbeiten!',
    en: 'Austria job search ✔ job offers for employers ✔ vacancies in Austria ✔ Search for industries and locations ✔ Find out now and work in Austria!',
  };

  // temp Title
  get titleSid(): { de: string, en: string } {
    if (ThemesModule.sample.title) {
      return ThemesModule.sample.title;
    }
    return {
      de: 'Arbeiten in Österreich – Jobs suchen ✔ | WORK IN AUSTRIA',
      en: 'Working in Austria – find jobs in austria | WORK IN AUSTRIA',
    };
  }

  get bannerImgSid() {
    return 'welcome_banner';
  }

  get isKle() {
    return ['kle', 'bbg', 'en'].includes(this.sid);
  }

  // en: логотип із текстом замість банера з каунтерами
  get isHeroLogo() {
    return this.sid === 'en';
  }

  heroText = 'Finden Sie passende Stellenangebote im Ennepe-Ruhr-Kreis und in der Umgebung. '
    + 'Das Jobcenter EN Stellenportal bringt Arbeitssuchende und regionale Arbeitgeber einfach und direkt zusammen.';

  get individualBanner() {
    return individualBannerGroup(this.sid);
  }

  get bannerImgUrl(): string | undefined {
    if (!portalBannerGroup(this.sid) || !this.headerImage) return undefined;
    return `${SERVER_URL}${this.headerImage}`;
  }

  get title() {
    return AppModule.settingPortal.html_title;
  }

  get contentTitle() {
    return AppModule.settingPortal.content_title;
  }

  get contentDescription() {
    return AppModule.settingPortal.content_description;
  }

  get searchPlaceholder() {
    return AppModule.settingPortal.search_input_jobs_placeholder || `${this.translations[9503]}...`;
  }

  get aiSearchPlaceholder() {
    return AppModule.settingPortal.ai_search_hint || this.translations[15928];
  }

  get headerImage() {
    return AppModule.settingPortal.header_image;
  }

  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }

  get sid() {
    return AppModule.sid;
  }

  get isHide() {
    return !['aba', 'abatest'].includes(this.sid);
  }

  get allCount(): number {
    return Number(AppModule.setting?.all_count || 0);
  }

  get allCountCompany(): number {
    return Number(AppModule.setting?.companies_count || 0);
  }

  get allCountWorkers(): number {
    return Number(AppModule.setting?.applicant_search_tab?.overall_applicants_count || 0);
  }

  get allCountCurses(): number {
    return Number(AppModule.setting?.courses_search_tab?.overall_courses_count || 0);
  }

  get isAlternativeCountTheme() {
    return ['wconat', 't4a'].includes(this.sid);
  }

  get countsData() {
    return [
      {
        count: this.allCountCompany,
        title: this.translations[14670],
        link: '/company',
        order: this.getCounterDataOrder('companies'),
        visibility: this.getCounterDataVisibility('companies'),
      },
      {
        count: this.allCountWorkers,
        title: this.translations[14671],
        link: '/workers',
        order: this.getCounterDataOrder('applicants'),
        visibility: this.getCounterDataVisibility('applicants'),
      },
      {
        count: this.allCount,
        title: this.translations[14672],
        link: '/jobs',
        order: this.getCounterDataOrder('jobs'),
        visibility: this.getCounterDataVisibility('jobs'),
      },
      {
        count: this.allCountCurses,
        title: this.translations[15404],
        link: '/courses',
        order: this.getCounterDataOrder('courses'),
        visibility: this.getCounterDataVisibility('courses'),
      },
    ]
      .filter((el) => el.visibility)
      .sort((a, b) => a.order - b.order);
  }

  getCounterDataOrder(value: SettingsCounters['name']) {
    return AppModule.settingPortal.counters.findIndex((el) => el.name === value);
  }

  getCounterDataVisibility(value: SettingsCounters['name']) {
    return !!AppModule.settingPortal.counters.find((el) => el.name === value)?.visible;
  }

  options = {
    useEasing: true,
    useGrouping: true,
    separator: AppModule.language === 'en' ? ',' : '.',
    decimal: '.',
    prefix: '',
    suffix: '',
  };

  // search
  get selectProfession() {
    return ProfessionModule.searchJobProfession;
  }

  set selectProfession(value: any) {
    ProfessionModule.SetSearchJobProfession(value);
    ProfessionModule.SetSearchJobProfessionTitle(value);
    ProfessionModule.SetSearch({ obj: 'profession_id', value: value?.map((v: any) => v.id).join(',') || null });
  }

  get selectLocation() {
    return ProfessionModule.searchJobLocation;
  }

  set selectLocation(value: any) {
    ProfessionModule.SetSearchJobLocation(value);
    ProfessionModule.SetSearchJobLocationTitle(value);
    ProfessionModule.SetSearch({ obj: 'location_id', value: value?.id || null });
  }

  searchFilter() {
    ProfessionModule.SetJobType(JobType.search);
  }

  // full-text search
  get searchText() {
    return ProfessionModule.jobSearch.q;
  }

  set searchText(value) {
    ProfessionModule.SetSearch({ obj: 'q', value });
    ProfessionModule.SetSearch({ obj: 'qmode', value: 2 });
  }

  // radius search
  get radius() {
    return ProfessionModule.jobSearch.radius;
  }

  set radius(value) {
    ProfessionModule.SetSearch({ obj: 'radius', value });
    ProfessionModule.SetSearchTags({ tag: 'radius', value });
  }
  // full-text search

  search() {
    ProfessionModule.SET_FILTER_DEFAULT();
    ProfessionModule.SET_SEARCH_DEFAULT();
    ProfessionModule.SET_PARAMS_DEFAULT();
    ProfessionModule.SET_TAGS_DEFAULT();
    ProfessionModule.SetProfessionTitle('');
    ProfessionModule.SetJobType(JobType.search);
    AppModule.SetVisibleMap(false);
    AppModule.SetVisibleJobs(true);
    AppModule.SetVisibleClusterJobs(false);
    AppModule.SET_WELCOME(true);
    this.$router.push({ name: 'Jobs', query: { lang: AppModule.language } });
  }

  async searchAi() {
    this.aiSearchLoading = true;
    try {
      await this.applyAiFilters(this.aiSearchText, true);
    } finally {
      this.aiSearchLoading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome-hero {
  min-height: 30rem;
  &__text {
    font-size: 17px;
    line-height: 1.6;
    color: #333333;
  }
  @media (max-width: 991.98px) {
    min-height: 0;
  }
}
.welcome-count {
  &__number {
    @media (max-width: 998.98px) {
      font-size: calc(2rem + 1.5vw);
    }
    @media (max-width: 767.98px) {
      font-size: calc(1.5rem + 1.5vw);
    }
    @media (max-width: 575.98px) {
      font-size: calc(1.2rem + 2vw);
      line-height: 1.15;
    }
  }
  &__text {
    @media (max-width: 767.98px) {
      font-size: calc(1rem + 0.3vw) !important;
    }
    @media (max-width: 575.98px) {
      font-size: 15px !important;
      line-height: 1.25;
    }
  }
}
</style>
